
import Vue from 'vue'

import { MetaInfo } from 'vue-meta'

import AuroraBackground from '~/components/common/aurora-background.vue'
import TextPressure from '~/components/common/text-pressure.vue'
import FooterNew from '~/components/FooterNew.vue'
import TextPressureMixin from '~/mixins/text-pressure.vue'
import EventKv from '~/sections/event/kv.vue'

export default Vue.extend({
  name: 'EventPage',
  components: {
    TextPressure,
    AuroraBackground,
    EventKv,
    FooterNew
  },
  mixins: [TextPressureMixin],
  layout: 'home',

  head(): MetaInfo {
    const title = 'EVENT'
    const extendMeta = this.$helper.setMetaTitleAndDescription(title)

    return {
      title,
      meta: [...extendMeta]
    }
  }
})
